module.exports = __webpack_public_path__ + "img/success.fb22b171.svg";